/**
 * Holds a list of supported components.
 *
 * The configuration is structured as such so in the future, lazy loading will be applied.
 * At the moment, name is used.
 *
 * TODO: Lazy load component
 *
 * @author Lemuel Raganas
 */
import * as lobj from "lodash/object";
class ComponentRegistry {
  private components: any = {};
  constructor() {
    this.components = {
      cna: "Cna.vue",
      "component-test": "ComponentTest.vue",
      "data-broker": "DataBroker.vue",
      "match-table": "MatchTable.vue",
      "fixture": "Fixture.vue",
      "match": "Match.vue",
      "points-table": "PointsTable.vue",
      "navbar": "Navbar.vue",
      "knockout": "Knockout.vue",
      "where-to-watch": "WhereToWatch.vue",
      "most-relevant": "MostRelevant.vue",
    };
  }

  hasComponent(name: string) {
    const componentName = name.toLowerCase();
    const fileName = lobj.get(this.components, name);
    if (fileName !== undefined && fileName !== null) {
      return true;
    }

    return false;
  }

  getFile(name: string) {
    const componentName = name.toLowerCase();
    return lobj.get(this.components, name);
  }

  getComponentPath(name: string) {
    const componentName = name.toLowerCase();
    const fileName = lobj.get(this.components, name);
    if (fileName !== undefined && fileName !== null) {
      return "./components/" + fileName;
    }

    return undefined;
  }

  getComponents(): string[] {
    const keys: string[] = lobj.keys(this.components);
    return keys;
  }
}

export default new ComponentRegistry();